import { getFrequencyStats } from '../../../helpers/api'
import moment from 'moment'

export default {
	getFrequency: ({ commit }, { token, data }) => {
		commit('SET_LOADING', true)
		const { interval, start, end } = data
		let intervalUrl
		let startFormatted
		let endFormatted

		switch (interval) {
			case 'month':
				intervalUrl = 'by-month'
				break
			case 'week':
				intervalUrl = 'by-week'
				break
			case 'day':
				intervalUrl = 'by-day'
				break
			default:
				intervalUrl = 'by-month'
				break
		}

		if (start instanceof Date) {
			startFormatted = Math.floor(start.getTime() / 1000)
		} else if (start && typeof start.unix === 'function') {
			startFormatted = start.unix()
		} else if (typeof start === 'string') {
			startFormatted = moment(start).unix()
		}

		if (end instanceof Date) {
			endFormatted = Math.floor(end.getTime() / 1000)
		} else if (end && typeof end.unix === 'function') {
			endFormatted = end.unix()
		} else if (typeof end === 'string') {
			endFormatted = moment(end).unix()
		}

		return getFrequencyStats(intervalUrl, token, startFormatted, endFormatted).then((data) => {
			commit('SET_LOADING', false)
			commit('SET_FREQUENCY', data)
			return true
		}).catch((err) => {
			commit('SET_LOADING', false)
			throw err
		})
	}
}
